import React, { Fragment, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import styles from './ReviewConfirmation.module.scss'

const PlateOwnerInfo = ({ t, setIsError, i18n, isMobile }) => {
  const history = useHistory()
  const { fullName, masterNumber } = useSelector((state) => state.app)

  useEffect(() => {
    try {
      if (!fullName || !masterNumber) {
        history.push(`/${i18n.language}${t('routes.contact_info')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  const editContactInfoOnClick = () => {
    history.push(`/${i18n.language}${t('routes.contact_info')}`)
  }

  const headerColSpan = isMobile ? '2' : '1'
  const valueColSpan = '3'

  const rowHeaderColSpan = isMobile ? '2' : '1'
  const rowValueColSpan = isMobile ? '3' : '4'

  return (
    <Fragment>
      <div className="row row-odd">
        <div className="col-xs-6">
          <strong>{t('review_confirmation.full_name')}</strong>
        </div>
        <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
          {fullName.toUpperCase()}
          <a
            href="javascript:void(0);"
            className={[styles['edit_button_right']].join(' ')}
            onClick={editContactInfoOnClick}
            value={`driving school info ${t('review_confirmation.edit')}`}
            name={`driving school info ${t('review_confirmation.edit')}`}
          >
            {t('review_confirmation.edit')}
          </a>
        </div>
      </div>
      <div className="row row-even">
        <div className="col-xs-6">
          <strong>{t('review_confirmation.master_number')}</strong>
        </div>
        <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
          {masterNumber}
        </div>
      </div>
    </Fragment>
  )
}

export default withTranslation('common')(PlateOwnerInfo)
